import { inherits as _inherits, createClass as _createClass, extends as _extends, classCallCheck as _classCallCheck, callSuper as _callSuper, defineProperty as _defineProperty } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types';
import { i18n } from '../i18n/translate.js';
import { Button } from './Button/index.js';
import { LanguageModal } from './Modals/LanguageModal/index.js';
import { SchoolModal } from './Modals/SchoolModal.js';
import { HelpModal } from './Modals/HelpModal.js';
import { ConfirmationModal } from './ConfirmationModal/index.js';
import { WindowHelperWrapper } from '../utils/WindowHelper.js';
import { getActiveRuleSetFromUrl } from '../utils/UrlUtil.js';
import { HeaderMenuAppSwitcher } from './HeaderMenuAppSwitcher.js';
import { FAIcon } from './fa-icon/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
var EXPANDED_HEADER_BREAKPOINT = 768;
/**
  This component is used to generate a Header menu from an object array.
  - It supports two types of menu items: Links and Dropdowns
  - Format for menuData:
    {
      submenu_items: [{
        icon: 'user',
        title: 'Menu Title',
        target_url: '/users',
        css_class: '',
        slug: '',
        submenu_items: [{
          icon: 'user',
          title: 'Submenu title',
          css_class: '',
          target_url: '/users/add',
          target_method: 'GET',
          new_window: false,
          slug: ''
        }]
      }]
    }
*/

var HeaderMenu = /*#__PURE__*/function (_Component) {
  function HeaderMenu(props) {
    var _this;

    _classCallCheck(this, HeaderMenu);

    _this = _callSuper(this, HeaderMenu, [props]);

    _defineProperty(_this, "checkHeader", function (fullWidth) {
      _this.setState({
        isMobile: !fullWidth
      });
    });

    _defineProperty(_this, "toggleLanguageModal", function () {
      _this.setState({
        showLanguageModal: !_this.state.showLanguageModal
      });
    });

    _defineProperty(_this, "toggleSchoolModal", function () {
      _this.setState({
        showSchoolModal: !_this.state.showSchoolModal
      });
    });

    _defineProperty(_this, "toggleHelpModal", function () {
      _this.setState({
        showHelpModal: !_this.state.showHelpModal
      });
    });

    _defineProperty(_this, "toggleConfirmationModal", function () {
      if (_this.props.selectedLanguage !== 'en') {
        window.location.reload();
      } else {
        _this.goBackToAdminPortal();
      }
    });

    _defineProperty(_this, "goBackToAdminPortal", function () {
      var _this$props = _this.props,
          adminifiDomain = _this$props.adminifiDomain,
          organizationSlug = _this$props.organizationSlug;
      var _this$state = _this.state,
          redirectUrl = _this$state.redirectUrl,
          redirectRuleSetName = _this$state.redirectRuleSetName;
      var url = redirectUrl;

      if (adminifiDomain) {
        url = "".concat(adminifiDomain, "/en/").concat(organizationSlug, "/cportal/reports");
        if (redirectRuleSetName) url = "".concat(url, "?current_rule_set_name=").concat(redirectRuleSetName);
      }

      _this.windowHelper.redirect(url);
    });

    _defineProperty(_this, "onToggleDropdown", function (open, id, event) {
      if ((event === null || event === void 0 ? void 0 : event.source) === 'rootClose') {
        _this.setState({
          dropdowns: {}
        });
      } else {
        _this.toggleDropdown(id, open);
      }
    });

    _defineProperty(_this, "toggleDropdown", function (key, open) {
      _this.setState({
        dropdowns: _defineProperty({}, key, open)
      });
    });

    _defineProperty(_this, "buttonOrLink", function (item, target_url) {
      var isDropdown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var buttonClick = {};

      if (target_url === 'language_modal') {
        buttonClick.onClick = function () {
          return _this.toggleLanguageModal();
        };
      } else if (target_url === 'school_modal') {
        buttonClick.onClick = function () {
          return _this.toggleSchoolModal();
        };
      } else if (target_url === 'help_modal') {
        buttonClick.onClick = function () {
          return _this.toggleHelpModal();
        };
      } else if (target_url === 'confirmation_modal') {
        buttonClick.onClick = function () {
          return _this.toggleConfirmationModal();
        };
      } else if (item.slug === 'logout') {
        buttonClick.onClick = function () {
          return _this.props.onStopImpersonation();
        };

        buttonClick.href = target_url;
      } else {
        buttonClick.href = target_url;
        buttonClick.target = item.new_window ? '_blank' : '_self';

        if (isDropdown) {
          buttonClick['data-method'] = item.target_method && !_this.props.isImpersonating ? item.target_method : 'GET';
        }
      }

      return buttonClick;
    });

    _defineProperty(_this, "renderLanguageModal", function () {
      var _this$props2;

      return /*#__PURE__*/React.createElement(LanguageModal, {
        renderAsLegacy: true,
        appendLanguage: !!((_this$props2 = _this.props) !== null && _this$props2 !== void 0 && _this$props2.appendLanguage),
        showLanguageModal: _this.state.showLanguageModal,
        toggleLanguageModal: _this.toggleLanguageModal,
        languages: _this.props.languages,
        selectedLanguage: _this.props.selectedLanguage
      });
    });

    _defineProperty(_this, "renderSchoolModal", function () {
      var _this$props3 = _this.props,
          homeroomDomain = _this$props3.homeroomDomain,
          user = _this$props3.user;
      return /*#__PURE__*/React.createElement(SchoolModal, {
        homeroomDomain: homeroomDomain,
        showSchoolModal: _this.state.showSchoolModal,
        toggleSchoolModal: _this.toggleSchoolModal,
        user: user
      });
    });

    _defineProperty(_this, "renderHelpModal", function () {
      return /*#__PURE__*/React.createElement(HelpModal, {
        helpMessage: _this.props.helpMessage,
        helpMessageEnabled: _this.props.helpMessageEnabled,
        isFoundry: _this.props.isFoundry,
        showHelpModal: _this.state.showHelpModal,
        toggleHelpModal: _this.toggleHelpModal,
        user: _this.props.user
      });
    });

    _defineProperty(_this, "renderConfirmationModal", function () {
      return /*#__PURE__*/React.createElement(ConfirmationModal, {
        onConfirm: _this.goBackToAdminPortal,
        onCancel: _this.toggleConfirmationModal,
        show: _this.state.showConfirmationModal
      }, i18n.t('You have selected to switch to the Admin Dashboard. The Admin Dashboard currently supports English only.'));
    });

    _defineProperty(_this, "runSwitch", function (redirectUrl) {
      var url = new URL(redirectUrl);
      var current_rule_set_name = url.searchParams.get('current_rule_set_name');

      if (current_rule_set_name === 'cc_admin' && _this.props.selectedLanguage !== 'en') {
        _this.setState({
          showConfirmationModal: true,
          redirectRuleSetName: current_rule_set_name,
          redirectUrl: redirectUrl
        });
      } else {
        _this.windowHelper.redirect(redirectUrl);
      }
    });

    _defineProperty(_this, "renderDropdown", function (menuItem, key) {
      var _this$props4 = _this.props,
          currentRuleSets = _this$props4.currentRuleSets,
          showCloseButton = _this$props4.showCloseButton; // handle special app-switcher menu

      if (menuItem.slug === 'app-switcher') {
        var hasActiveRuleSet = getActiveRuleSetFromUrl(currentRuleSets); // show app switcher if there is an active rule set

        if (hasActiveRuleSet !== null && hasActiveRuleSet !== void 0 && hasActiveRuleSet.name) {
          return /*#__PURE__*/React.createElement(HeaderMenuAppSwitcher, {
            currentRuleSets: currentRuleSets,
            menuItems: menuItem.submenu_items,
            onRedirect: _this.runSwitch
          });
        } else {
          return null;
        }
      }

      var isAccount = menuItem.css_class === 'account';
      var menuId = "headerMenu-".concat(key);

      var menuLabel = _this.getMenuLabel(menuItem);

      return /*#__PURE__*/React.createElement(Dropdown, {
        id: menuId,
        className: menuItem.css_class,
        onToggle: function onToggle(open, event) {
          return _this.onToggleDropdown(open, menuId, event);
        },
        show: _this.state.dropdowns[menuId]
      }, /*#__PURE__*/React.createElement(Dropdown.Toggle, {
        variant: "default",
        className: "ui-compact",
        "aria-label": menuLabel
      }, !isAccount && menuItem.icon && /*#__PURE__*/React.createElement(FAIcon, {
        additionalClasses: "left",
        icon: menuItem.icon,
        color: "gray"
      }), /*#__PURE__*/React.createElement("span", {
        "aria-hidden": true
      }, menuLabel), isAccount && /*#__PURE__*/React.createElement(FAIcon, {
        additionalClasses: "right",
        icon: "bars",
        color: "gray"
      })), /*#__PURE__*/React.createElement(Dropdown.Menu, {
        className: "user-menu"
      }, showCloseButton && /*#__PURE__*/React.createElement("div", {
        className: "mobile-close",
        "aria-label": i18n.t('Close'),
        onClick: function onClick() {
          return _this.toggleDropdown(menuId, false);
        }
      }, "\xD7"), _this.renderDropdownMenuItems(menuItem)));
    });

    _defineProperty(_this, "renderDropdownMenuItems", function (menuItem) {
      var menuItemElements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      menuItem.submenu_items.forEach(function (item, subKey) {
        if (item.subsection) {
          if (subKey) {
            menuItemElements.push( /*#__PURE__*/React.createElement(Dropdown.Item, {
              key: menuItemElements.length,
              divider: true
            }));
          }

          _this.renderDropdownMenuItems(item, menuItemElements);

          return;
        }

        var adminDashboardLink = _this.props.user && item.target_url === "".concat(_this.props.adminifiDomain, "/").concat(_this.props.organizationSlug, "/cportal/reports");
        var href = adminDashboardLink ? 'confirmation_modal' : item.target_url;

        var buttonClick = _this.buttonOrLink(item, href, true);

        var menuTitle = menuItem.slug || menuItem.css_class;
        var dataAttribute = item.data_attribute || null;

        if (_this.showMenuItem(item)) {
          menuItemElements.push( /*#__PURE__*/React.createElement(Dropdown.Item, _extends({
            key: menuItemElements.length,
            id: "headerMenu-".concat(menuTitle, "-headerMenuItem-").concat(subKey),
            "data-attribute": dataAttribute,
            className: item.sub_text ? 'has-sub-text' : ''
          }, buttonClick), item.icon && /*#__PURE__*/React.createElement(FAIcon, {
            icon: item.icon
          }), item.title, item.sub_text && /*#__PURE__*/React.createElement("span", {
            className: "menu-sub-text ".concat(item.css_class)
          }, item.sub_text)));
        }
      });
      return menuItemElements;
    });

    _defineProperty(_this, "setOpenDropdownClass", function () {
      if (typeof window === 'undefined') {
        return;
      }

      var openDropdownClass = 'header-menu-dropdown-open';
      var body = document.querySelector('body');
      var anyDropdownsOpen = Object.keys(_this.state.dropdowns).length && Object.values(_this.state.dropdowns).some(function (val) {
        return !!val;
      });
      var bodyHasOpenClass = body.classList.contains(openDropdownClass);

      if (anyDropdownsOpen && !bodyHasOpenClass) {
        body.classList.add(openDropdownClass);
      } else if (!anyDropdownsOpen && bodyHasOpenClass) {
        body.classList.remove(openDropdownClass);
      }
    });

    var serverSide = typeof window === 'undefined';
    var dropdowns = {};
    _this.windowHelper = WindowHelperWrapper(props.windowOverride);
    props.menuData.submenu_items.forEach(function (item, key) {
      if (item.submenu_items && item.submenu_items.length) dropdowns["headerMenu-".concat(key)] = false;
    });
    _this.state = {
      showConfirmationModal: false,
      showLanguageModal: false,
      showSchoolModal: false,
      showHelpModal: false,
      isMobile: serverSide && props.isMobile,
      serverSide: serverSide,
      dropdowns: dropdowns,
      redirectRuleSetName: null,
      redirectUrl: null
    };
    return _this;
  }

  _inherits(HeaderMenu, _Component);

  return _createClass(HeaderMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.state.serverSide) {
        this.destroyWindowWatcher = this.windowHelper.watchBreakpoints(EXPANDED_HEADER_BREAKPOINT, this.checkHeader);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.state.serverSide) {
        this.destroyWindowWatcher();
      }
    }
  }, {
    key: "showMenuItem",
    value: function showMenuItem(item) {
      return item.slug !== 'logout' || !this.props.isImpersonating;
    }
  }, {
    key: "getMenuLabel",
    value: function getMenuLabel(item) {
      var prefix = item.css_class === 'account' && this.props.isImpersonating ? i18n.t('Impersonating ') : '';
      return "".concat(prefix).concat(item.title);
    }
  }, {
    key: "renderLink",
    value: function renderLink(menuItem, key) {
      var buttonClick = this.buttonOrLink(menuItem, menuItem.target_url);

      var className = _formatClassName(['branded-link', 'btn', 'ui-compact', menuItem.css_class]);

      return /*#__PURE__*/React.createElement(Button, _extends({
        id: "headerMenu-".concat(key),
        className: className,
        style: "neutral",
        label: menuItem.title,
        title: menuItem.title,
        "aria-label": menuItem.title,
        tabIndex: 0,
        "data-action": menuItem.title.toLowerCase(),
        icon: menuItem.icon
      }, buttonClick));
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var menuData = this.props.menuData;
      return menuData.submenu_items.map(function (item, key) {
        return /*#__PURE__*/React.createElement("li", {
          key: key
        }, item.submenu_items && item.submenu_items.length ? _this2.renderDropdown(item, key) : _this2.renderLink(item, key));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          additionalNavClass = _this$props5.additionalNavClass,
          hideNameOnMobile = _this$props5.hideNameOnMobile,
          pullRight = _this$props5.pullRight;
      this.setOpenDropdownClass();

      var classNames = _formatClassName(['header-menu', {
        'mobile-hide-name': hideNameOnMobile
      }, {
        'pull-right': pullRight
      }, additionalNavClass]);

      return /*#__PURE__*/React.createElement("nav", {
        className: classNames,
        "aria-label": i18n.t('Header Menu')
      }, /*#__PURE__*/React.createElement("ul", {
        role: "presentation"
      }, this.renderChildren()), this.renderLanguageModal(), this.renderSchoolModal(), this.renderHelpModal(), this.renderConfirmationModal());
    }
  }]);
}(Component);

HeaderMenu.displayName = "HeaderMenu";
HeaderMenu.propTypes = {
  additionalNavClass: PropTypes.string,
  adminifiDomain: PropTypes.string,
  appendLanguage: PropTypes.bool,
  currentRuleSets: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.bool
  })),
  helpMessage: PropTypes.string,
  helpMessageEnabled: PropTypes.bool,
  hideNameOnMobile: PropTypes.bool,
  homeroomDomain: PropTypes.string,
  isFoundry: PropTypes.bool,
  isImpersonating: PropTypes.bool,
  isMobile: PropTypes.bool,
  languages: PropTypes.object,
  menuData: PropTypes.shape({
    submenu_items: PropTypes.arrayOf(PropTypes.shape({
      icon: PropTypes.string,
      title: PropTypes.string.isRequired,

      /** if you set the css class to account, the menu item will have a different set of style rules */
      css_class: PropTypes.string,
      target_url: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,

      /** this will indicate if the menu item is either a Link or a Dropdown */
      submenu_items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        target_url: PropTypes.string.isRequired,
        target_method: PropTypes.string,
        new_window: PropTypes.bool.isRequired,
        slug: PropTypes.string.isRequired
      }))
    }))
  }).isRequired,
  onStopImpersonation: PropTypes.func,
  organizationSlug: PropTypes.string,
  pullRight: PropTypes.bool,
  selectedLanguage: PropTypes.string,
  showCloseButton: PropTypes.bool,
  user: PropTypes.object,
  windowOverride: PropTypes.object
};
HeaderMenu.defaultProps = {
  hideNameOnMobile: true,
  menuData: {},
  pullRight: true,
  showCloseButton: true,
  user: null
};
export { HeaderMenu };